let self = null;

export default class DontCalculateBackwardDirectionBehavior {
    constructor(parentContext) {
        self = parentContext;
    }

    calculateBakwardDirection(position, angle) {
        return angle;
    }
}


// WEBPACK FOOTER //
// ./src/components/parts/PathMover/Behavior/BackwardDirectionBehavior/DontCalculateBackwardDirectionBehavior.js